export interface ChartBuildOptions {
  /** Options for an SVG export (PDF report) rather than for the screen. */
  forExport?: boolean;
}

const TROPHY_LABEL = '<span style="opacity: 1 !important;">🏆</span>';
// HTML labels are left out of exported SVGs and the report font has no emoji: the export writes a word instead.
const EXPORT_BEST_LABEL = '<b>Best</b>';

/** Data label marking the best value: HTML on screen, plain SVG text for an export. */
export const bestValueDataLabel = (forExport: boolean | undefined) => ({
  useHTML: !forExport,
  text: forExport ? EXPORT_BEST_LABEL : TROPHY_LABEL,
});
